import React from 'react'
import { Badge } from 'reactstrap'

import { formatDateByLanguage } from 'utils/formatters'
import Icon from 'common/Icon'
import PdfLink from 'common/PdfLink'

import { TableListStatus, TableListStatusItem } from 'components/Case/CaseDetail/TableList'

export default ({ resource, invoiceItem, status }) => {
  const { documentIndex, attachmentId, languageCode } = invoiceItem

  return (
    <TableListStatus>
      {/* === 1. Invoice Created / Sent === */}
      <TableListStatusItem>
        <div className="d-flex align-items-center">
          <Badge color={status.salesInvoiceSent ? 'success' : 'danger'}>
            <Icon icon={status.salesInvoiceSent ? 'done' : 'clear'} className="md-12" />
          </Badge>
          <span className="ms-2 me-1">
            {status.dateInvoiceScheduledForSending && status.isInvoiceScheduledForSending
              ? resource.Scheduled
              : resource.InvoiceSent}
          </span>
          {attachmentId && (
            <PdfLink fileId={attachmentId} fileName={documentIndex} title={resource.DownloadInvoicePdf} />
          )}
        </div>
        {(status.salesInvoiceSent || status.dateInvoiceScheduledForSending) && (
          <small className="text-muted">
            <em>
              {formatDateByLanguage(
                status.dateSalesInvoiceSent || status.dateInvoiceScheduledForSending,
                'DD MMMM YYYY H:mm',languageCode
              )}
            </em>
          </small>
        )}
      </TableListStatusItem>

      {/* === 2. Invoice Expiry date === */}

      <TableListStatusItem>
        <div className="d-flex align-items-center">
          <Badge color="success">
            <Icon icon="done" className="md-12" />
          </Badge>

          <span className="ms-2 me-1">{resource.SentToClientAP}</span>
        </div>

        <small className="text-muted">
          <em>{formatDateByLanguage(status.dateSalesInvoiceExpiry, 'DD MMMM YYYY H:mm',languageCode)}</em>
        </small>
      </TableListStatusItem>

      {/* === 3. Invoice Paid === */}
      {/* === Invoice Paid / Settled / Not Paid === */}
      {status.salesInvoicePaid ? (
        <TableListStatusItem>
          <div className="d-flex align-items-center">
            <Badge color="success">
              <Icon icon="done_all" className="md-12" />
            </Badge>
            <span className="ms-2 me-1">{resource.InvoicePaid}</span>
          </div>
          <small className="text-muted">
            <em>{formatDateByLanguage(status.dateSalesInvoicePaid, 'DD MMMM YYYY H:mm',languageCode)}</em>
          </small>
        </TableListStatusItem>
      ) : status.salesInvoiceSettled ? (
        <TableListStatusItem>
          <div className="d-flex align-items-center">
            <Badge color="secondary">
              <Icon icon="remove_circle_outline" className="md-12" />
            </Badge>
            <span className="ms-2 me-1">{resource.InvoicePaid}</span>
          </div>
          <small className="text-muted">
            <em>{formatDateByLanguage(status.dateSalesInvoiceSettled, 'DD MMMM YYYY H:mm',languageCode)}</em>
          </small>
        </TableListStatusItem>
      ) : (
        <TableListStatusItem>
          <div className="d-flex align-items-center">
            <Badge color="danger">
              <Icon icon="clear" className="md-12" />
            </Badge>
            <span className="ms-2 me-1">{resource.InvoicePaid}</span>
          </div>
        </TableListStatusItem>
      )}
    </TableListStatus>
  )
}
